import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import ToolTip from "@material-ui/core/Tooltip";
import Add from "@material-ui/icons/Add";
import cancelIcon from "Assets/Svg/cancel.svg";
import DynamicForm from "Component/DynamicForm";
import { dateinputconverter } from "Component/DynamicForm/Fields/Date";
import { integerinputconverter } from "Component/DynamicForm/Fields/Integer";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import Thumbnail from "Component/Thumbnail/ThumbnailSmall";
import { ErrorMessages } from "Constants";
import Configs from "Constants/Configs";
import { getUrlExtension } from "Handlers/getters";
import get from "lodash/get";
import React from "react";
import Dropzone from "react-dropzone";
import { FormattedMessage } from "react-intl";
import { instance, instanceMultipart } from "../../../../Actions/AxiosInstance";
import addressEmployee from "../../../../Assets/Images/education.svg";
import documentIcon from "../../../../Assets/Svg/document-icon.svg";
import If from "../../../../Component/Common/If";
import { convertDateForBackend, getFormattedDate } from "../../../../Utils";
import CreateComp from "../create";
import { NoRecordFound } from "../EmpMainProfile/NoRecordFound";

class IdentityDocuments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accountid: null,
      subscriptionid: null,
      countrytimezoneid: null,
      employeeid: null,
      ShortDateFormat: null,
      colleagueid: null,
      datareceived: true,
      docList: [],
      hideButton: false,
      customdata: [],
      selecteddoc: null,
      fielddata: null,
      newattachments: [],
      subcustomdataid: null,
      fields: [],
      deleteattachments: [],
      flag: 0,
    };

    this.addMore = this.addMore.bind(this);
    this.onEditClicked = this.onEditClicked.bind(this);
    this.getFields = this.getFields.bind(this);
    this.getFiles = this.getFiles.bind(this);
    this.onSave = this.onSave.bind(this);
    this.updatechange = this.updatechange.bind(this);
    this.removeImg = this.removeImg.bind(this);
    this.removeFile = this.removeFile.bind(this);
    this.getIntroComponent = this.getIntroComponent.bind(this);
    this.getViewComponent = this.getViewComponent.bind(this);
    this.getEditComponent = this.getEditComponent.bind(this);
    this.getFormattedImageLink = this.getFormattedImageLink.bind(this);
  }

  getFormattedImageLink(link) {
    const ext1 = getUrlExtension(link);
    // const ext1 = ext || getUrlExtension(docUrl);
    switch (ext1) {
      case "jpg":
      case "jpeg":
      case "png":
        return `${Configs.STORE_URL}${link}`;
      case "pdf":
      case "ppt":
      case "pptx":
      case "doc":
      case "docx":
      case "txt":
      case "text":
      case "rtf":
      case "odt":
        return documentIcon;
      default:
        return null;
    }
  }

  componentDidMount() {
    const { SubscriptionData } = this.props;
    const { accountid } = SubscriptionData;
    const { subscriptionid } = SubscriptionData;
    const { countrytimezoneid } = SubscriptionData;
    const DateFormat = get("SubscriptionData.dateformatname", "");
    let ShortDateFormat =
      typeof DateFormat === "string" ? DateFormat.split(" ") : [""];
    ShortDateFormat = getFormattedDate(ShortDateFormat[0]);
    let employeeid;
    employeeid = SubscriptionData.employeeid;

    const { AuthenticationAction } = this.props;
    if (AuthenticationAction.IsFulfilled) {
      employeeid = AuthenticationAction.login.employeeid;
    }
    const { colleagueid } = this.props.match.params;

    const masterprofileid = get(
      AuthenticationAction,
      "login.masterprofileid",
      9,
    );
    const { permissions } = this.props;
    let hideButton;
    permissions.editable
      ? colleagueid && colleagueid != employeeid
        ? masterprofileid != 9
          ? (hideButton = true)
          : (hideButton = false)
        : (hideButton = false)
      : masterprofileid != 9
      ? (hideButton = true)
      : (hideButton = false);
    this.setState(
      {
        accountid,
        subscriptionid,
        countrytimezoneid,
        employeeid,
        ShortDateFormat,
        colleagueid,
        hideButton,
      },
      () => {
        this.getList();
      },
    );
  }

  removeFile(docDetails) {
    console.log("docDetails: ", docDetails);
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",
      action: [
        <Button
          key="1"
          color="inherit"
          size="small"
          onClick={() => {
            this.props.closeSnackbar();
            instance
              .get(
                `subscription/deleteemployeecustomdata/${docDetails.employeecustomdataid}`,
              )
              .then(() => {
                this.getList();
                this.props.enqueueSnackbar("Deleted successfully", {
                  variant: "success",
                });
              })
              .catch((error) => {
                const CommonError = error.response
                  ? error.response.data.error.message
                  : error.message;
                this.props.enqueueSnackbar(CommonError, { variant: "error" });
              });
          }}
        >
          Yes
        </Button>,
        <Button
          key="2"
          color="inherit"
          size="small"
          onClick={() =>
            this.setState({ createmenu: false }, () =>
              this.props.closeSnackbar(),
            )
          }
        >
          No
        </Button>,
      ],
    });
  }

  getList() {
    const data = {
      employeeid: this.state.colleagueid || this.state.employeeid,
      isidentity: true,
    };
    instance
      .post("subscription/getemployeecustomdata", data)
      .then((result) => {
        this.setState({
          docList: result.data.result,
          flag:
            result.data.result.length == 1 &&
            !result.data.result[0].employeecustomdataid &&
            result.data.result[0].addbutton
              ? 0
              : 1,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  addMore() {
    const data = {
      employeeid: this.state.colleagueid || this.state.employeeid,
      isidentity: true,
    };
    instance
      .post("subscription/getemployeecustomdatalist", data)
      .then((result) => {
        this.setState({
          customdata: [
            ...result.data.result.map((obj) => ({
              ...obj,
              displayname: obj.sectionname,
              displayvalue: obj.subcustomdataid,
            })),
          ],
          flag: 2,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  onEditClicked(doc) {
    this.setState({
      flag: 2,
      selecteddoc: doc,
    });
  }

  getFields(key, value) {
    this.setState(
      {
        [key]: value,
      },
      () => {
        instance
          .get(`subscription/getcustomdatabyid/${value}`)
          .then((result) => {
            this.setState({
              docList: result.data.result,
              fielddata: {
                ...result.data.result[0],
                field: result.data.result[0].field.map((x) => ({
                  ...x,
                  fieldvalue: null,
                  fieldoptionid: null,
                })),
              },
            });
          })
          .catch((error) => {
            const CommonError = error.response
              ? error.response.data.error.message
              : error.message;
            this.props.enqueueSnackbar(CommonError, { variant: "error" });
          });
      },
    );
  }

  getFiles(files) {
    const { AuthenticationAction } = this.props;
    const id = this.state.colleagueid || this.state.employeeid;
    const file = files[0];
    const formData = new FormData();
    formData.append("file", file);
    instanceMultipart
      .post(
        `/drive/uploaddocument/${AuthenticationAction.login.subscriptionid}/${id}`,
        formData,
      )
      .then((resp) => {
        const { newattachments } = this.state;
        newattachments.push({
          ...resp.data.result[0],
        });
        this.setState({ newattachments });
      });
  }

  onSave() {
    const {
      selecteddoc,
      fielddata,
      colleagueid,
      employeeid,
      subcustomdataid,
      deleteattachments,
      newattachments,
    } = this.state;

    const allfields = selecteddoc
      ? selecteddoc.field &&
        selecteddoc.field.map((x) => ({
          subcustomdatafieldid: x.subcustomdatafieldid,
          fieldoptionid:
            x.inputvaluetypeid == 4 ? x.fieldvalue : x.fieldoptionid,
          fieldvalue:
            x.inputvaluetypeid == 4
              ? x.fieldoptionid
              : x.inputvaluetypeid == 3
              ? convertDateForBackend(x.fieldvalue)
              : x.fieldvalue,
          isrequired: x.isrequired,
        }))
      : fielddata &&
        fielddata.field &&
        fielddata.field.map((x) => ({
          subcustomdatafieldid: x.subcustomdatafieldid,
          fieldoptionid:
            x.inputvaluetypeid == 4 ? x.fieldvalue : x.fieldoptionid,
          fieldvalue:
            x.inputvaluetypeid == 4
              ? x.fieldoptionid
              : x.inputvaluetypeid == 3
              ? convertDateForBackend(x.fieldvalue)
              : x.fieldvalue,
          isrequired: x.isrequired,
        }));

    let valid = true;
    valid =
      allfields && allfields.find((obj) => obj.isrequired && !obj.fieldvalue)
        ? false
        : true;
    // valid = selecteddoc
    //   ? selecteddoc.attachment && selecteddoc.attachment.length > 0
    //     ? true
    //     : newattachments.length == 0
    //       ? false
    //       : true
    //   : newattachments.length == 0
    //     ? false
    //     : true;

    if (valid) {
      const data = {
        employeecustomdataid: selecteddoc
          ? selecteddoc.employeecustomdataid
          : null,
        employeeid: colleagueid || employeeid,
        subcustomdataid: selecteddoc
          ? selecteddoc.subcustomdataid
          : subcustomdataid,
        filetagtypeid: selecteddoc
          ? selecteddoc.filetagtypeid
          : fielddata
          ? fielddata.filetagtypeid
          : 0,
        field: allfields,
        deletedocument: selecteddoc
          ? deleteattachments.length > 0
            ? deleteattachments
            : null
          : null,
        updatedocument: selecteddoc
          ? selecteddoc.attachment &&
            selecteddoc.attachment.map((x) => x.documentid)
          : null,
        insertdocument: newattachments,
      };
      console.log("data: ", data);
      instance
        .post(`subscription/configemployeecustomdata`, data)
        .then(() => {
          this.props.enqueueSnackbar(ErrorMessages.E0000, {
            variant: "success",
          });
          this.setState(
            {
              docList: [],
              selecteddoc: null,
              fielddata: null,
              subcustomdataid: null,
              flag: 1,
              customdata: [],
              fields: [],
              deleteattachments: [],
              newattachments: [],
            },
            () => {
              this.getList();
            },
          );
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else {
      this.props.enqueueSnackbar(ErrorMessages.E0020, { variant: "error" });
    }
  }

  updatechange(key, value, findex, selectedname) {
    console.log(
      "key, value, findex, selectedname: ",
      key,
      value,
      findex,
      selectedname,
    );
    const { selecteddoc, fielddata } = this.state;
    const all = selecteddoc
      ? selecteddoc.field && selecteddoc.field
      : fielddata && fielddata.field;
    if (all && all.length > 0) {
      all[findex][key] = value;
      all[findex].fieldoptionid = selectedname ? selectedname : null;
    }
    if (selecteddoc) {
      selecteddoc.field = all;
    } else if (fielddata) {
      fielddata.field = all;
    }
    this.setState({
      selecteddoc,
      fielddata,
    });
  }

  removeImg(index, id) {
    const { deleteattachments, selecteddoc } = this.state;
    deleteattachments.push(id);
    selecteddoc &&
      selecteddoc.attachment &&
      selecteddoc.attachment.splice(index, 1);
    this.setState({
      deleteattachments,
      selecteddoc,
    });
  }

  getIntroComponent() {
    const { hideButton } = this.state;
    return (
      <div>
        <Grid container>
          <Grid item xs={12} md={12} sm={12}>
            {!hideButton ? (
              <CreateComp
                text="Add your documents."
                heading="Identity document details"
                onCreate={this.addMore}
                imageSrc={addressEmployee}
              />
            ) : (
              <NoRecordFound />
            )}
          </Grid>
        </Grid>
      </div>
    );
  }

  getViewComponent() {
    const { hideButton, docList } = this.state;
    return (
      <div
        className="profile-data-view-page width97 thin-scroll"
        style={{ overflowY: "auto" }}
      >
        <Grid container>
          {docList &&
            docList.length > 0 &&
            docList.map((doc) => (
              <Grid container className="margin-bottom-20">
                <Grid item xs={12} md={5}>
                  <div className="t-16 t-bold text-color-blue">
                    {doc.sectionname}
                  </div>
                  {doc.field &&
                    doc.field.map((x) => (
                      <div style={{ marginTop: "3%" }}>
                        <div
                          className="small-dark-secondary t-bold"
                          style={{ marginTop: "5%" }}
                        >
                          {x.fieldname}
                        </div>
                        <div className="t-16">
                          {x.inputvaluetypeid == 3
                            ? getFormattedDate(x.fieldvalue)
                            : x.fieldvalue
                            ? x.fieldvalue
                            : " - "}
                          {/* {(x.inputvaluetypeid == 3) ? getFormattedDate(x.fieldvalue) : " - "} */}
                        </div>
                      </div>
                    ))}
                </Grid>
                <Grid item xs={12} md={5}>
                  <div className="small-dark-secondary t-bold">Attachments</div>
                  <div>
                    {doc.attachment &&
                      doc.attachment.length > 0 &&
                      doc.attachment.map((d) => (
                        // <div className="floatleft" style={{ height: 48 }}>
                        //   <div key="img" className="add-attachment">
                        //     <img src={getFormattedImageLink(d.documentpath)} className="expense-attachment-img" />
                        //   </div>
                        // </div>
                        <Thumbnail
                          canDelete={false}
                          key="i"
                          doc={{ url: d.documentpath }}
                        />
                      ))}
                  </div>
                </Grid>
                <Grid item xs={12} md={2}>
                  {!hideButton && (
                    <div className="position-rel">
                      {doc.editbutton && (
                        <svg
                          className="address-edit cursour-pointer"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          style={{ marginRight: 40 }}
                          onClick={() => this.onEditClicked(doc)}
                        >
                          <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z" />
                        </svg>
                      )}
                      <svg
                        className={
                          // this.state.hideButton
                          //   ? "hide-button"
                          //   :
                          "address-edit cursour-pointer"
                        }
                        onClick={() => this.removeFile(doc)}
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z" />
                        <path fill="none" d="M0 0h24v24H0V0z" />
                      </svg>
                    </div>
                  )}
                </Grid>
              </Grid>
            ))}
          {!hideButton && docList && docList[0] && docList[0].addbutton && (
            <Button
              style={{
                background: "#166ab3",
                color: "white",
                marginTop: "3%",
                marginBottom: "15%",
              }}
              onClick={this.addMore}
              className="LbAddmore"
            >
              <span>
                <FormattedMessage id="LbAddmore" defaultMessage="ADD MORE" />
              </span>
            </Button>
          )}
        </Grid>
      </div>
    );
  }

  getEditComponent() {
    const { docList, subcustomdataid, selecteddoc, fielddata, newattachments } =
      this.state;
    return (
      <div className="profile-data-view-page emp-from-wrapper work-experience width60 custom">
        {!selecteddoc ? (
          <DynamicForm
            className="document"
            fields={selectinputconverter({
              value: subcustomdataid,
              options: this.state.customdata,
              placeholder: "Select custom document",
              label: "Custom document",
            })}
            onChange={(e) => this.getFields("subcustomdataid", e)}
          />
        ) : (
          <div className="t-16 t-bold text-color-blue custom1">
            {selecteddoc && selecteddoc.sectionname}
          </div>
        )}
        {selecteddoc
          ? selecteddoc.field &&
            selecteddoc.field.map((x, fi) => (
              <div>
                {x.inputvaluetypeid == 1 ? (
                  <DynamicForm
                    fields={textinputconverter({
                      value: x.fieldvalue,
                      placeholder: "",
                      label: `${x.fieldname} ${
                        !x.isrequired ? " (Optional)" : ""
                      }`,
                    })}
                    onChange={(e) => this.updatechange("fieldvalue", e, fi)}
                  />
                ) : x.inputvaluetypeid == 2 ? (
                  <DynamicForm
                    fields={integerinputconverter({
                      value: x.fieldvalue,
                      placeholder: "",
                      min: 0,
                      max: 1000,
                      label: `${x.fieldname} ${
                        !x.isrequired ? " (Optional)" : ""
                      }`,
                    })}
                    onChange={(e) => this.updatechange("fieldvalue", e, fi)}
                  />
                ) : x.inputvaluetypeid == 3 ? (
                  <DynamicForm
                    fields={dateinputconverter({
                      value: x.fieldvalue,
                      placeholder: "",
                      min: x.isexpiryfield ? new Date() : null,
                      label: `${x.fieldname} ${
                        !x.isrequired ? " (Optional)" : ""
                      }`,
                    })}
                    onChange={(e) => this.updatechange("fieldvalue", e, fi)}
                  />
                ) : (
                  <DynamicForm
                    fields={selectinputconverter({
                      options: x.option.map((y) => ({
                        ...y,
                        displayvalue: y.subcustomdatafieldoptionid,
                        displayname: y.optionname,
                      })),
                      value: x.option.find(
                        (obj) =>
                          obj.subcustomdatafieldoptionid == x.fieldoptionid,
                      )
                        ? x.fieldoptionid
                        : x.fieldvalue,
                      min: 0,
                      max: 1000,
                      placeholder: "",
                      label: `${x.fieldname} ${
                        !x.isrequired ? " (Optional)" : ""
                      }`,
                    })}
                    onChange={(e) =>
                      this.updatechange(
                        "fieldvalue",
                        e,
                        fi,
                        x.option.find(
                          (obj) => obj.subcustomdatafieldoptionid == e,
                        ) &&
                          x.option.find(
                            (obj) => obj.subcustomdatafieldoptionid == e,
                          ).optionname,
                      )
                    }
                  />
                )}
              </div>
            ))
          : fielddata &&
            fielddata.field &&
            fielddata.field.map((x, fi) => (
              <div>
                {x.inputvaluetypeid == 1 ? (
                  <DynamicForm
                    fields={textinputconverter({
                      value: x.fieldvalue,
                      placeholder: "",
                      label: `${x.fieldname} ${
                        !x.isrequired ? " (Optional)" : ""
                      }`,
                    })}
                    onChange={(e) => this.updatechange("fieldvalue", e, fi)}
                  />
                ) : x.inputvaluetypeid == 2 ? (
                  <DynamicForm
                    fields={integerinputconverter({
                      value: x.fieldvalue,
                      placeholder: "",
                      min: 0,
                      max: 1000,
                      label: `${x.fieldname} ${
                        !x.isrequired ? " (Optional)" : ""
                      }`,
                    })}
                    onChange={(e) => this.updatechange("fieldvalue", e, fi)}
                  />
                ) : x.inputvaluetypeid == 3 ? (
                  <DynamicForm
                    fields={dateinputconverter({
                      value: x.fieldvalue,
                      placeholder: "",
                      min: x.isexpiryfield ? new Date() : null,
                      label: `${x.fieldname} ${
                        !x.isrequired ? " (Optional)" : ""
                      }`,
                    })}
                    onChange={(e) => this.updatechange("fieldvalue", e, fi)}
                  />
                ) : (
                  <DynamicForm
                    fields={selectinputconverter({
                      options: x.option.map((y) => ({
                        ...y,
                        displayvalue: y.subcustomdatafieldoptionid,
                        displayname: y.optionname,
                      })),
                      value: x.fieldvalue,
                      min: 0,
                      max: 1000,
                      placeholder: "",
                      label: `${x.fieldname} ${
                        !x.isrequired ? " (Optional)" : ""
                      }`,
                    })}
                    onChange={(e) =>
                      this.updatechange(
                        "fieldvalue",
                        e,
                        fi,
                        x.option.find(
                          (obj) => obj.subcustomdatafieldoptionid == e,
                        ) &&
                          x.option.find(
                            (obj) => obj.subcustomdatafieldoptionid == e,
                          ).optionname,
                      )
                    }
                  />
                )}
              </div>
            ))}
        <div className="input-label">Attachments</div>
        <div style={{ height: 70 }}>
          {selecteddoc &&
            selecteddoc.attachment &&
            selecteddoc.attachment.map((img, imgindex) => (
              <div
                key="img"
                className="add-attachment"
                style={{ marginRight: 16 }}
              >
                <img
                  src={this.getFormattedImageLink(img.documentpath)}
                  className="expense-attachment-img"
                />
                <img
                  src={cancelIcon}
                  className="remove-attachment-icon"
                  style={{ zIndex: 0 }}
                  onClick={() => this.removeImg(imgindex, img.documentid)}
                />
              </div>
            ))}
          {newattachments &&
            newattachments.map((img, imgindex) => (
              <div
                key="img"
                className="add-attachment"
                style={{ marginRight: 16 }}
              >
                <img
                  src={
                    img &&
                    img.imagepath &&
                    this.getFormattedImageLink(img.imagepath)
                  }
                  className="expense-attachment-img"
                />
                <img
                  src={cancelIcon}
                  style={{ zIndex: 0 }}
                  className="remove-attachment-icon"
                  onClick={() => {
                    const all = newattachments;
                    all.splice(imgindex, 1);
                    this.setState({
                      newattachments: all,
                    });
                  }}
                />
              </div>
            ))}
          <Grid
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div className="add-attachment">
              <ToolTip title="Insert attachment" placement="right">
                <Dropzone
                  onDrop={this.getFiles}
                  multiple={false}
                  accept="image/gif, image/jpeg, image/png, image/jpg, .pdf "
                  maxSize={10485760}
                  className="drag-drop"
                >
                  <Add className="add-attachement-icon" />
                </Dropzone>
              </ToolTip>
            </div>
          </Grid>

          <p className="input-label">
            Note:<br></br>
              Supported files: .gif, .jpeg, .jpg, .png and .pdf<br></br>
              Max size: 10MB
          </p>
          
          {/* <p className="input-label">Note: we can upload upto 10 MB</p> */}
          {/* <div className="add-attachment">
            <ToolTip title="Upload file" placement="right">
              <Dropzone
                onDrop={this.getFiles}
                multiple={false}
                accept="image/gif, image/jpeg, image/png, image/jpg, .pdf"
                maxSize={2000000}
                className="drag-drop"
              >
                <Add className="add-attachement-icon" />
              </Dropzone>
            </ToolTip>
          </div> */}
        </div>
        <Grid container>
          <div style={{ marginTop: 60 }}>
            <Button
              color="primary"
              className="btn btn-primary-md-blue margin-right-8"
              variant="contained"
              onClick={this.onSave}
            >
              save
            </Button>
            <Button
              color="primary"
              className="btn btn-secondary-md-blue margin-right-16 cancel"
              variant="contained"
              onClick={() =>
                this.setState(
                  {
                    flag:
                      docList.length == 1 &&
                      !docList[0].employeecustomdataid &&
                      docList[0].addbutton
                        ? 0
                        : 1,
                    customdata: [],
                    selecteddoc: null,
                    fielddata: null,
                    deleteattachments: [],
                    newattachments: [],
                    subcustomdataid: null,
                    fields: [],
                    docList: [],
                  },
                  () => {
                    this.getList();
                  },
                )
              }
            >
              Cancel
            </Button>
          </div>
        </Grid>
      </div>
    );
  }

  render() {
    const { datareceived, flag } = this.state;

    return (
      <div>
        <If condition={datareceived}>
          <If condition={flag == 0}>{this.getIntroComponent()}</If>
          <If condition={flag == 1}>{this.getViewComponent()}</If>
          <If condition={flag == 2}>{this.getEditComponent()}</If>
        </If>
      </div>
    );
  }
}

export default IdentityDocuments;
